import MessageToast from '@/features/toasts/components/MessageToast.vue';
import { useToastStore } from '@/features/toasts/stores/useToastStore';
import { PiniaColadaQueryHooksPlugin } from '@pinia/colada'


export const onError = (error: unknown) => {
    const toast = useToastStore();

    let message = 'Unknown error';
    if (typeof error === 'object' && error !== null && 'message' in error && typeof error.message === 'string') {
        try {
            const parsedError = JSON.parse(error.message);

            message = parsedError?.message || message;
        } catch (e) {
            console.warn('Failed to parse error message:', e);
        }
    }

    toast.addToast({
        status: 'error',
        content: MessageToast,
        props: {
            title: 'Error',
            message,
        }
    });
}

export const PiniaColadaErrorToast = PiniaColadaQueryHooksPlugin({
    onError,
})